(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@loipham/material-base", [], factory);
	else if(typeof exports === 'object')
		exports["base"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["base"] = factory();
})(this, function() {
return 